import { useEffect } from 'react';

export const useFetchStockOnMount = ({ modalVisible, isStockInStore, fetchStores, selectedZone, setModalBusy }) => {
  useEffect(() => {
    if (modalVisible && isStockInStore) {
      fetchStores({
        comuna: selectedZone,
        setBusy: setModalBusy,
      });
    }
  }, [modalVisible]);
};

export const useCloseModalOnFlag = ({ shouldClose, setShouldClose, setModalVisible }) => {
  useEffect(() => {
    if (shouldClose) {
      setModalVisible(false);
      setShouldClose(false);
    }
  }, [shouldClose]);
};
